var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { useMediaQuery } from 'react-responsive';
import { muiBankTheme } from '../tools/theme';
var Media = Object.entries(muiBankTheme.mediaSizes).reduce(function (acc, _a) {
    var _b;
    var _c = __read(_a, 2), key = _c[0], value = _c[1];
    return __assign(__assign({}, acc), (_b = {}, _b[key] = function (_a) {
        var children = _a.children;
        var shouldRender = useMediaQuery(value);
        return shouldRender ? React.createElement(React.Fragment, null, children) : null;
    }, _b));
}, {});
export { Media };
//# sourceMappingURL=Media.js.map